import React, { useState } from 'react';

import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import Input from 'components/formsy/Input';

import APICkecker from '../APICkecker';

export default function RexadzPartner({ name, data = {} }) {
  const [apikey, setApikey] = useState(data.apikey || '')

  return <>
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>API Key</Label>
          <Input required
            name="apikey"
            value={apikey}
            onChange={setApikey}
          />
        </FormGroup>
      </Col>
    </Row>
    <APICkecker
      partner={name}
      credentials={{ apikey }}
    />
  </>
}
